import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const items = [
  { key: 'pourqui_1', icon: 'ri-building-2-line' },
  { key: 'pourqui_2', icon: 'ri-hotel-line' },
  { key: 'pourqui_3', icon: 'ri-home-smile-line' },
  { key: 'pourqui_4', icon: 'ri-car-line' },
  { key: 'pourqui_5', icon: 'ri-store-2-line' },
];

export default function PourQui() {
  const { t } = useTranslation('toitplat');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="pour-qui" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('pourqui_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-4 p-5 md:p-6 bg-soft-gray rounded-xl transition-all duration-700 hover:bg-white hover:shadow-sm hover:border-copper/20 border border-transparent ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 100 + 200}ms` }}
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg bg-copper/10">
                <i className={`${item.icon} text-copper text-xl`} />
              </div>
              <span className="text-slate-primary font-medium text-sm md:text-base pt-2">
                {t(item.key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}